import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { apiErrorMessage } from "@/lib/apiError";

export default function ChangePasswordCard() {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [next2, setNext2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== next2) { toast.error("New passwords don't match"); return; }
    if (next.length < 8) { toast.error("Password must be 8+ characters"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated");
      setCurrent(""); setNext(""); setNext2("");
    } catch (err) {
      toast.error(apiErrorMessage(err, "Could not update password"));
    } finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="border border-border p-6 space-y-4" data-testid="settings-change-password">
      <div className="label-eyebrow">Security · Change password</div>
      <div className="grid md:grid-cols-3 gap-4">
        <div>
          <Label className="label-eyebrow mb-2 inline-block">Current password</Label>
          <Input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required className="h-10" data-testid="cp-current" />
        </div>
        <div>
          <Label className="label-eyebrow mb-2 inline-block">New password</Label>
          <Input type="password" value={next} onChange={(e) => setNext(e.target.value)} required minLength={8} className="h-10" data-testid="cp-new" />
        </div>
        <div>
          <Label className="label-eyebrow mb-2 inline-block">Confirm new password</Label>
          <Input type="password" value={next2} onChange={(e) => setNext2(e.target.value)} required minLength={8} className="h-10" data-testid="cp-new2" />
        </div>
      </div>
      <div className="flex justify-end">
        <Button type="submit" disabled={busy || !current || !next} className="rounded-none" data-testid="cp-submit">
          {busy ? "Updating…" : "Update password"}
        </Button>
      </div>
    </form>
  );
}
